import { render, staticRenderFns } from "./HomeSlider.vue?vue&type=template&id=12b0cd12"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"
import style0 from "./HomeSlider.vue?vue&type=style&index=0&id=12b0cd12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports